import 'babel-polyfill'
import './assets/scripts/remove.polyfill'

// use vue
import Vue from 'vue'
import App from './app.vue'

// use vue-router
import { createRouter } from './router'

// use vuex
import { createStore } from '@/store'

// use i18n
import i18n from '@/i18n'

// import global stylesheets
import 'normalize.css/normalize.css'

// use element ui
import ElementUI from 'element-ui'
import '@/assets/stylesheets/theme/index.css'

// using default css
import '@/assets/stylesheets/default.scss'

// import global mixins
import utils from '@/mixins/utils.global'
import session from '@/mixins/session.global'

// import logger
import logger from '@/assets/scripts/logger'

// import api
import ApiBase from '@/api/api_base'

// import crosstab
import crosstab from 'crosstab'

// self-defined plugins
import contacts from '@/plugins/contacts.alert'
import dialogs from '@/plugins/dialogs'

// import global component
import ImageUploader from '@/components/widgets/image_uploader'
import Spinner from '@/components/widgets/spinner'
import CellphoneInput from '@/components/widgets/cellphone.input'

// import clipboard support
import VueClipboard from 'vue-clipboard2'

// register global component
Vue.component('image-uploader', ImageUploader)
Vue.component('spinner', Spinner)
Vue.component('cellphone-input', CellphoneInput)

Vue.use(ElementUI)
// custom global mixins
Vue.mixin(utils)
Vue.mixin(session)

// use external plugins
Vue.use(VueClipboard)

// use custom plugins
Vue.use(contacts)
Vue.use(dialogs)

let store = createStore(i18n)
let a = new Vue({
  el: '#main',
  render: h => h(App),
  store,
  router: createRouter(store),
  i18n
})
logger.debug(a)

// 如果有其他同源tab发送refresh vuex 请求
crosstab.on('refresh', res => {
  // block refresh request from current tab
  if (crosstab.id !== res.origin) {
    a.$store.dispatch('refresh')
  }
})

// set api base
ApiBase.setVueStore(store)
ApiBase.setVueRoot(a)



// WEBPACK FOOTER //
// ./src/main.js